module.exports = __webpack_public_path__ + "img/badge_color_hs-college.b3980b61.svg";